import React, { FC } from 'react'
import { Banner } from '../../../../../../../../components/Banner/desktop'
import AdmissionInstruction from '../../../../../../../uz/components/AdmissionInstruction/desktop'
import { useRotationBannerAndAdmissionInstructions } from '../bll'

export const RotationBannerAndAdmissionInstructions: FC = () => {
  const {
    showAdmissionInstruction,
    hasPaidPackage,
    institutionId,
    admissionInstruction,
    programTypes,
  } = useRotationBannerAndAdmissionInstructions()

  if (showAdmissionInstruction) {
    return (
      <AdmissionInstruction
        institutionId={institutionId}
        admissionInstruction={admissionInstruction}
      />
    )
  }

  return (
    <>
      {!hasPaidPackage && (
        <Banner
          id={4}
          spacing={{
            bottom: 'xxlarge',
          }}
          extraParams={programTypes}
        />
      )}
    </>
  )
}
